// extracted by mini-css-extract-plugin
export default {"root":"ExternalModelThumbnail_root__PfGUg","active":"ExternalModelThumbnail_active__SMl1o","title":"ExternalModelThumbnail_title__ehTB4"};